// React
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

// Libraries
import { Provider } from 'react-redux'

// Components
import CollectionList from 'store/modules/product/components/CollectionList'
import { CartPickerButton } from 'store/modules/cart/CartPicker/Button'
import Themed from 'store/v2/react/components/Themed'

// Shared

const store = window.booqableStore

export default class Sidebar extends Component {
  static displayName = 'Sidebar'

  static propTypes = {
    filterKey: PropTypes.string
  }

  static defaultProps = {
    filterKey: 'global'
  }

  render () {
    const { filterKey } = this.props

    return (
      <Provider store={store}>
        <Themed>
          <Fragment>
            <CartPickerButton />
            <div className="booqable-component">
              <CollectionList horizontalRule filterKey={filterKey} />
            </div>
          </Fragment>
        </Themed>
      </Provider>
    )
  }
}
